export const getLengthOfSms = value => {
  const tmp = document.createElement('DIV')
  tmp.innerHTML = value
  const length = tmp.textContent.length || tmp.innerText.length || 0
  return length
}